// source: proto/admpb/tablesettings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.admpb.CreateRoleTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.CreateTableColumnsResponse', null, global);
goog.exportSymbol('proto.admpb.CreateTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.EmptyRoleTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.EmptyTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.ReadRoleTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.ReadTableColumnsResponse', null, global);
goog.exportSymbol('proto.admpb.ReadTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.RoleTableSettings', null, global);
goog.exportSymbol('proto.admpb.TableColumns', null, global);
goog.exportSymbol('proto.admpb.TableSettings', null, global);
goog.exportSymbol('proto.admpb.UpdateRoleTableSettingsResponse', null, global);
goog.exportSymbol('proto.admpb.UpdateTableColumnsResponse', null, global);
goog.exportSymbol('proto.admpb.UpdateTableSettingsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.TableSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.TableSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.TableSettings.displayName = 'proto.admpb.TableSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.CreateTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.CreateTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.CreateTableSettingsResponse.displayName = 'proto.admpb.CreateTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.UpdateTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.UpdateTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.UpdateTableSettingsResponse.displayName = 'proto.admpb.UpdateTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ReadTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.ReadTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ReadTableSettingsResponse.displayName = 'proto.admpb.ReadTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.CreateRoleTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.CreateRoleTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.CreateRoleTableSettingsResponse.displayName = 'proto.admpb.CreateRoleTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.RoleTableSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.RoleTableSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.RoleTableSettings.displayName = 'proto.admpb.RoleTableSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.TableColumns = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.TableColumns, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.TableColumns.displayName = 'proto.admpb.TableColumns';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.UpdateRoleTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.UpdateRoleTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.UpdateRoleTableSettingsResponse.displayName = 'proto.admpb.UpdateRoleTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ReadRoleTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.ReadRoleTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ReadRoleTableSettingsResponse.displayName = 'proto.admpb.ReadRoleTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.CreateTableColumnsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.CreateTableColumnsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.CreateTableColumnsResponse.displayName = 'proto.admpb.CreateTableColumnsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.UpdateTableColumnsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.UpdateTableColumnsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.UpdateTableColumnsResponse.displayName = 'proto.admpb.UpdateTableColumnsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ReadTableColumnsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.ReadTableColumnsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ReadTableColumnsResponse.displayName = 'proto.admpb.ReadTableColumnsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.EmptyTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.EmptyTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.EmptyTableSettingsResponse.displayName = 'proto.admpb.EmptyTableSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.EmptyRoleTableSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.EmptyRoleTableSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.EmptyRoleTableSettingsResponse.displayName = 'proto.admpb.EmptyRoleTableSettingsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.TableSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.TableSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.TableSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.TableSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    settingsId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    usrId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    gridName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    visibleColumns: jspb.Message.getFieldWithDefault(msg, 4, ""),
    columnOrder: jspb.Message.getFieldWithDefault(msg, 5, ""),
    component: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.TableSettings}
 */
proto.admpb.TableSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.TableSettings;
  return proto.admpb.TableSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.TableSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.TableSettings}
 */
proto.admpb.TableSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSettingsId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsrId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGridName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibleColumns(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnOrder(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.TableSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.TableSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.TableSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.TableSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettingsId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getGridName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVisibleColumns();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColumnOrder();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getComponent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint32 settings_id = 1;
 * @return {number}
 */
proto.admpb.TableSettings.prototype.getSettingsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.admpb.TableSettings} returns this
 */
proto.admpb.TableSettings.prototype.setSettingsId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 usr_id = 2;
 * @return {number}
 */
proto.admpb.TableSettings.prototype.getUsrId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.admpb.TableSettings} returns this
 */
proto.admpb.TableSettings.prototype.setUsrId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string grid_name = 3;
 * @return {string}
 */
proto.admpb.TableSettings.prototype.getGridName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableSettings} returns this
 */
proto.admpb.TableSettings.prototype.setGridName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string visible_columns = 4;
 * @return {string}
 */
proto.admpb.TableSettings.prototype.getVisibleColumns = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableSettings} returns this
 */
proto.admpb.TableSettings.prototype.setVisibleColumns = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string column_order = 5;
 * @return {string}
 */
proto.admpb.TableSettings.prototype.getColumnOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableSettings} returns this
 */
proto.admpb.TableSettings.prototype.setColumnOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string component = 6;
 * @return {string}
 */
proto.admpb.TableSettings.prototype.getComponent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableSettings} returns this
 */
proto.admpb.TableSettings.prototype.setComponent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.CreateTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.CreateTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.CreateTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableSettings: (f = msg.getTableSettings()) && proto.admpb.TableSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.CreateTableSettingsResponse}
 */
proto.admpb.CreateTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.CreateTableSettingsResponse;
  return proto.admpb.CreateTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.CreateTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.CreateTableSettingsResponse}
 */
proto.admpb.CreateTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.TableSettings;
      reader.readMessage(value,proto.admpb.TableSettings.deserializeBinaryFromReader);
      msg.setTableSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.CreateTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.CreateTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.CreateTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.TableSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableSettings table_settings = 1;
 * @return {?proto.admpb.TableSettings}
 */
proto.admpb.CreateTableSettingsResponse.prototype.getTableSettings = function() {
  return /** @type{?proto.admpb.TableSettings} */ (
    jspb.Message.getWrapperField(this, proto.admpb.TableSettings, 1));
};


/**
 * @param {?proto.admpb.TableSettings|undefined} value
 * @return {!proto.admpb.CreateTableSettingsResponse} returns this
*/
proto.admpb.CreateTableSettingsResponse.prototype.setTableSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.CreateTableSettingsResponse} returns this
 */
proto.admpb.CreateTableSettingsResponse.prototype.clearTableSettings = function() {
  return this.setTableSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.CreateTableSettingsResponse.prototype.hasTableSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.UpdateTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.UpdateTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.UpdateTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableSettings: (f = msg.getTableSettings()) && proto.admpb.TableSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.UpdateTableSettingsResponse}
 */
proto.admpb.UpdateTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.UpdateTableSettingsResponse;
  return proto.admpb.UpdateTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.UpdateTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.UpdateTableSettingsResponse}
 */
proto.admpb.UpdateTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.TableSettings;
      reader.readMessage(value,proto.admpb.TableSettings.deserializeBinaryFromReader);
      msg.setTableSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.UpdateTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.UpdateTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.UpdateTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.TableSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableSettings table_settings = 1;
 * @return {?proto.admpb.TableSettings}
 */
proto.admpb.UpdateTableSettingsResponse.prototype.getTableSettings = function() {
  return /** @type{?proto.admpb.TableSettings} */ (
    jspb.Message.getWrapperField(this, proto.admpb.TableSettings, 1));
};


/**
 * @param {?proto.admpb.TableSettings|undefined} value
 * @return {!proto.admpb.UpdateTableSettingsResponse} returns this
*/
proto.admpb.UpdateTableSettingsResponse.prototype.setTableSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.UpdateTableSettingsResponse} returns this
 */
proto.admpb.UpdateTableSettingsResponse.prototype.clearTableSettings = function() {
  return this.setTableSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.UpdateTableSettingsResponse.prototype.hasTableSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ReadTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ReadTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ReadTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableSetting: (f = msg.getTableSetting()) && proto.admpb.TableSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ReadTableSettingsResponse}
 */
proto.admpb.ReadTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ReadTableSettingsResponse;
  return proto.admpb.ReadTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ReadTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ReadTableSettingsResponse}
 */
proto.admpb.ReadTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.TableSettings;
      reader.readMessage(value,proto.admpb.TableSettings.deserializeBinaryFromReader);
      msg.setTableSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ReadTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ReadTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ReadTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.TableSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableSettings table_setting = 1;
 * @return {?proto.admpb.TableSettings}
 */
proto.admpb.ReadTableSettingsResponse.prototype.getTableSetting = function() {
  return /** @type{?proto.admpb.TableSettings} */ (
    jspb.Message.getWrapperField(this, proto.admpb.TableSettings, 1));
};


/**
 * @param {?proto.admpb.TableSettings|undefined} value
 * @return {!proto.admpb.ReadTableSettingsResponse} returns this
*/
proto.admpb.ReadTableSettingsResponse.prototype.setTableSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.ReadTableSettingsResponse} returns this
 */
proto.admpb.ReadTableSettingsResponse.prototype.clearTableSetting = function() {
  return this.setTableSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.ReadTableSettingsResponse.prototype.hasTableSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.CreateRoleTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.CreateRoleTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.CreateRoleTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateRoleTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    roleTableSetting: (f = msg.getRoleTableSetting()) && proto.admpb.RoleTableSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.CreateRoleTableSettingsResponse}
 */
proto.admpb.CreateRoleTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.CreateRoleTableSettingsResponse;
  return proto.admpb.CreateRoleTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.CreateRoleTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.CreateRoleTableSettingsResponse}
 */
proto.admpb.CreateRoleTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.RoleTableSettings;
      reader.readMessage(value,proto.admpb.RoleTableSettings.deserializeBinaryFromReader);
      msg.setRoleTableSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.CreateRoleTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.CreateRoleTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.CreateRoleTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateRoleTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoleTableSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.RoleTableSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoleTableSettings role_table_setting = 1;
 * @return {?proto.admpb.RoleTableSettings}
 */
proto.admpb.CreateRoleTableSettingsResponse.prototype.getRoleTableSetting = function() {
  return /** @type{?proto.admpb.RoleTableSettings} */ (
    jspb.Message.getWrapperField(this, proto.admpb.RoleTableSettings, 1));
};


/**
 * @param {?proto.admpb.RoleTableSettings|undefined} value
 * @return {!proto.admpb.CreateRoleTableSettingsResponse} returns this
*/
proto.admpb.CreateRoleTableSettingsResponse.prototype.setRoleTableSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.CreateRoleTableSettingsResponse} returns this
 */
proto.admpb.CreateRoleTableSettingsResponse.prototype.clearRoleTableSetting = function() {
  return this.setRoleTableSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.CreateRoleTableSettingsResponse.prototype.hasRoleTableSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.RoleTableSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.RoleTableSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.RoleTableSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.RoleTableSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    roleTableSettingsId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    roleId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    component: jspb.Message.getFieldWithDefault(msg, 3, ""),
    visibleColumns: jspb.Message.getFieldWithDefault(msg, 4, ""),
    columnOrder: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.RoleTableSettings}
 */
proto.admpb.RoleTableSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.RoleTableSettings;
  return proto.admpb.RoleTableSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.RoleTableSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.RoleTableSettings}
 */
proto.admpb.RoleTableSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoleTableSettingsId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoleId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisibleColumns(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.RoleTableSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.RoleTableSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.RoleTableSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.RoleTableSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoleTableSettingsId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getRoleId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getComponent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVisibleColumns();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getColumnOrder();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional uint32 role_table_settings_id = 1;
 * @return {number}
 */
proto.admpb.RoleTableSettings.prototype.getRoleTableSettingsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.admpb.RoleTableSettings} returns this
 */
proto.admpb.RoleTableSettings.prototype.setRoleTableSettingsId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 role_id = 2;
 * @return {number}
 */
proto.admpb.RoleTableSettings.prototype.getRoleId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.admpb.RoleTableSettings} returns this
 */
proto.admpb.RoleTableSettings.prototype.setRoleId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string component = 3;
 * @return {string}
 */
proto.admpb.RoleTableSettings.prototype.getComponent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.RoleTableSettings} returns this
 */
proto.admpb.RoleTableSettings.prototype.setComponent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string visible_columns = 4;
 * @return {string}
 */
proto.admpb.RoleTableSettings.prototype.getVisibleColumns = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.RoleTableSettings} returns this
 */
proto.admpb.RoleTableSettings.prototype.setVisibleColumns = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string column_order = 5;
 * @return {string}
 */
proto.admpb.RoleTableSettings.prototype.getColumnOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.RoleTableSettings} returns this
 */
proto.admpb.RoleTableSettings.prototype.setColumnOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.TableColumns.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.TableColumns.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.TableColumns} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.TableColumns.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableColumnsId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    component: jspb.Message.getFieldWithDefault(msg, 2, ""),
    columns: jspb.Message.getFieldWithDefault(msg, 3, ""),
    tableType: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.TableColumns}
 */
proto.admpb.TableColumns.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.TableColumns;
  return proto.admpb.TableColumns.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.TableColumns} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.TableColumns}
 */
proto.admpb.TableColumns.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTableColumnsId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumns(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTableType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.TableColumns.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.TableColumns.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.TableColumns} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.TableColumns.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableColumnsId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getComponent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getColumns();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTableType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 table_columns_id = 1;
 * @return {number}
 */
proto.admpb.TableColumns.prototype.getTableColumnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.admpb.TableColumns} returns this
 */
proto.admpb.TableColumns.prototype.setTableColumnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string component = 2;
 * @return {string}
 */
proto.admpb.TableColumns.prototype.getComponent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableColumns} returns this
 */
proto.admpb.TableColumns.prototype.setComponent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string columns = 3;
 * @return {string}
 */
proto.admpb.TableColumns.prototype.getColumns = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableColumns} returns this
 */
proto.admpb.TableColumns.prototype.setColumns = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string table_type = 4;
 * @return {string}
 */
proto.admpb.TableColumns.prototype.getTableType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.TableColumns} returns this
 */
proto.admpb.TableColumns.prototype.setTableType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.UpdateRoleTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.UpdateRoleTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.UpdateRoleTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateRoleTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    roleTableSetting: (f = msg.getRoleTableSetting()) && proto.admpb.RoleTableSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.UpdateRoleTableSettingsResponse}
 */
proto.admpb.UpdateRoleTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.UpdateRoleTableSettingsResponse;
  return proto.admpb.UpdateRoleTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.UpdateRoleTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.UpdateRoleTableSettingsResponse}
 */
proto.admpb.UpdateRoleTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.RoleTableSettings;
      reader.readMessage(value,proto.admpb.RoleTableSettings.deserializeBinaryFromReader);
      msg.setRoleTableSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.UpdateRoleTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.UpdateRoleTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.UpdateRoleTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateRoleTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoleTableSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.RoleTableSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoleTableSettings role_table_setting = 1;
 * @return {?proto.admpb.RoleTableSettings}
 */
proto.admpb.UpdateRoleTableSettingsResponse.prototype.getRoleTableSetting = function() {
  return /** @type{?proto.admpb.RoleTableSettings} */ (
    jspb.Message.getWrapperField(this, proto.admpb.RoleTableSettings, 1));
};


/**
 * @param {?proto.admpb.RoleTableSettings|undefined} value
 * @return {!proto.admpb.UpdateRoleTableSettingsResponse} returns this
*/
proto.admpb.UpdateRoleTableSettingsResponse.prototype.setRoleTableSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.UpdateRoleTableSettingsResponse} returns this
 */
proto.admpb.UpdateRoleTableSettingsResponse.prototype.clearRoleTableSetting = function() {
  return this.setRoleTableSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.UpdateRoleTableSettingsResponse.prototype.hasRoleTableSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ReadRoleTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ReadRoleTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ReadRoleTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadRoleTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    roleTableSetting: (f = msg.getRoleTableSetting()) && proto.admpb.RoleTableSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ReadRoleTableSettingsResponse}
 */
proto.admpb.ReadRoleTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ReadRoleTableSettingsResponse;
  return proto.admpb.ReadRoleTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ReadRoleTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ReadRoleTableSettingsResponse}
 */
proto.admpb.ReadRoleTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.RoleTableSettings;
      reader.readMessage(value,proto.admpb.RoleTableSettings.deserializeBinaryFromReader);
      msg.setRoleTableSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ReadRoleTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ReadRoleTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ReadRoleTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadRoleTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoleTableSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.RoleTableSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoleTableSettings role_table_setting = 1;
 * @return {?proto.admpb.RoleTableSettings}
 */
proto.admpb.ReadRoleTableSettingsResponse.prototype.getRoleTableSetting = function() {
  return /** @type{?proto.admpb.RoleTableSettings} */ (
    jspb.Message.getWrapperField(this, proto.admpb.RoleTableSettings, 1));
};


/**
 * @param {?proto.admpb.RoleTableSettings|undefined} value
 * @return {!proto.admpb.ReadRoleTableSettingsResponse} returns this
*/
proto.admpb.ReadRoleTableSettingsResponse.prototype.setRoleTableSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.ReadRoleTableSettingsResponse} returns this
 */
proto.admpb.ReadRoleTableSettingsResponse.prototype.clearRoleTableSetting = function() {
  return this.setRoleTableSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.ReadRoleTableSettingsResponse.prototype.hasRoleTableSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.CreateTableColumnsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.CreateTableColumnsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.CreateTableColumnsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateTableColumnsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableColumn: (f = msg.getTableColumn()) && proto.admpb.TableColumns.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.CreateTableColumnsResponse}
 */
proto.admpb.CreateTableColumnsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.CreateTableColumnsResponse;
  return proto.admpb.CreateTableColumnsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.CreateTableColumnsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.CreateTableColumnsResponse}
 */
proto.admpb.CreateTableColumnsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.TableColumns;
      reader.readMessage(value,proto.admpb.TableColumns.deserializeBinaryFromReader);
      msg.setTableColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.CreateTableColumnsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.CreateTableColumnsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.CreateTableColumnsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateTableColumnsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableColumn();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.TableColumns.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableColumns table_column = 1;
 * @return {?proto.admpb.TableColumns}
 */
proto.admpb.CreateTableColumnsResponse.prototype.getTableColumn = function() {
  return /** @type{?proto.admpb.TableColumns} */ (
    jspb.Message.getWrapperField(this, proto.admpb.TableColumns, 1));
};


/**
 * @param {?proto.admpb.TableColumns|undefined} value
 * @return {!proto.admpb.CreateTableColumnsResponse} returns this
*/
proto.admpb.CreateTableColumnsResponse.prototype.setTableColumn = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.CreateTableColumnsResponse} returns this
 */
proto.admpb.CreateTableColumnsResponse.prototype.clearTableColumn = function() {
  return this.setTableColumn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.CreateTableColumnsResponse.prototype.hasTableColumn = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.UpdateTableColumnsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.UpdateTableColumnsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.UpdateTableColumnsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateTableColumnsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableColumn: (f = msg.getTableColumn()) && proto.admpb.TableColumns.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.UpdateTableColumnsResponse}
 */
proto.admpb.UpdateTableColumnsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.UpdateTableColumnsResponse;
  return proto.admpb.UpdateTableColumnsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.UpdateTableColumnsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.UpdateTableColumnsResponse}
 */
proto.admpb.UpdateTableColumnsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.TableColumns;
      reader.readMessage(value,proto.admpb.TableColumns.deserializeBinaryFromReader);
      msg.setTableColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.UpdateTableColumnsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.UpdateTableColumnsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.UpdateTableColumnsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateTableColumnsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableColumn();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.TableColumns.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableColumns table_column = 1;
 * @return {?proto.admpb.TableColumns}
 */
proto.admpb.UpdateTableColumnsResponse.prototype.getTableColumn = function() {
  return /** @type{?proto.admpb.TableColumns} */ (
    jspb.Message.getWrapperField(this, proto.admpb.TableColumns, 1));
};


/**
 * @param {?proto.admpb.TableColumns|undefined} value
 * @return {!proto.admpb.UpdateTableColumnsResponse} returns this
*/
proto.admpb.UpdateTableColumnsResponse.prototype.setTableColumn = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.UpdateTableColumnsResponse} returns this
 */
proto.admpb.UpdateTableColumnsResponse.prototype.clearTableColumn = function() {
  return this.setTableColumn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.UpdateTableColumnsResponse.prototype.hasTableColumn = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ReadTableColumnsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ReadTableColumnsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ReadTableColumnsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadTableColumnsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableColumn: (f = msg.getTableColumn()) && proto.admpb.TableColumns.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ReadTableColumnsResponse}
 */
proto.admpb.ReadTableColumnsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ReadTableColumnsResponse;
  return proto.admpb.ReadTableColumnsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ReadTableColumnsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ReadTableColumnsResponse}
 */
proto.admpb.ReadTableColumnsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.TableColumns;
      reader.readMessage(value,proto.admpb.TableColumns.deserializeBinaryFromReader);
      msg.setTableColumn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ReadTableColumnsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ReadTableColumnsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ReadTableColumnsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadTableColumnsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableColumn();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.TableColumns.serializeBinaryToWriter
    );
  }
};


/**
 * optional TableColumns table_column = 1;
 * @return {?proto.admpb.TableColumns}
 */
proto.admpb.ReadTableColumnsResponse.prototype.getTableColumn = function() {
  return /** @type{?proto.admpb.TableColumns} */ (
    jspb.Message.getWrapperField(this, proto.admpb.TableColumns, 1));
};


/**
 * @param {?proto.admpb.TableColumns|undefined} value
 * @return {!proto.admpb.ReadTableColumnsResponse} returns this
*/
proto.admpb.ReadTableColumnsResponse.prototype.setTableColumn = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.ReadTableColumnsResponse} returns this
 */
proto.admpb.ReadTableColumnsResponse.prototype.clearTableColumn = function() {
  return this.setTableColumn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.ReadTableColumnsResponse.prototype.hasTableColumn = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.EmptyTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.EmptyTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.EmptyTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.EmptyTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.EmptyTableSettingsResponse}
 */
proto.admpb.EmptyTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.EmptyTableSettingsResponse;
  return proto.admpb.EmptyTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.EmptyTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.EmptyTableSettingsResponse}
 */
proto.admpb.EmptyTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.EmptyTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.EmptyTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.EmptyTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.EmptyTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.EmptyRoleTableSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.EmptyRoleTableSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.EmptyRoleTableSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.EmptyRoleTableSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.EmptyRoleTableSettingsResponse}
 */
proto.admpb.EmptyRoleTableSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.EmptyRoleTableSettingsResponse;
  return proto.admpb.EmptyRoleTableSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.EmptyRoleTableSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.EmptyRoleTableSettingsResponse}
 */
proto.admpb.EmptyRoleTableSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.EmptyRoleTableSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.EmptyRoleTableSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.EmptyRoleTableSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.EmptyRoleTableSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.admpb);
